import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-activatevoice',
  templateUrl: './activatevoice.component.html',
  styleUrls: ['./activatevoice.component.css']
})
export class ActivatevoiceComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
